import { AXIOM } from "@/constants/testIds";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid={AXIOM.footer} className="bg-bg border-t border-rule">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets-rejwkqb3.emergentagent.net/job_engineer-axiom/artifacts/h00nh5nc_ChatGPT%20Image%20Jul%2014%2C%202026%2C%2005_38_12%20PM.png"
                alt="AxiomForge"
                className="h-10 md:h-12 w-auto"
              />
              <div
                className="wordmark text-ink"
                style={{ fontSize: "clamp(32px, 4vw, 48px)", lineHeight: 1 }}
              >
                <span>Axiom</span><span className="text-forge">Forge</span>
              </div>
            </div>
            <div className="mt-3 font-mono text-[11px] tracking-[0.14em] uppercase text-smoke">
              Designed. Validated. Manufactured.
            </div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="eyebrow mb-3">Location</div>
            <div className="text-ink/85 text-[14px] leading-[1.7]">
              Mumbai · India
            </div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="eyebrow mb-3">Contact</div>
            <div className="text-ink/85 text-[14px] leading-[1.7]">
              <a href="mailto:hello@axiomforge.in" className="hover:text-forge transition-colors">hello@axiomforge.in</a>
            </div>
          </div>
        </div>
        <div className="rule mt-10" />
        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[11px] tracking-[0.12em] uppercase text-smoke">
          <div>© {year} AxiomForge - All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
